import { defineComponent as _defineComponent } from 'vue'
import { useStore, computed } from '@nuxtjs/composition-api';
import { CardData, CardType, isAlgoliaResource } from '~/composables/useCardData';
import { useUser } from '~/composables/useUser';
import { useDownload } from '~/composables/useDownload';
import { usePermissions } from '~/composables/usePermissions';
import { AlgoliaResource, Resource } from '~/types/resource';
import { State } from '~/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardActions',
  props: {
    resource: null,
    item: null,
    type: null
  },
  setup(__props: any) {

const props = __props as {
  resource: Resource | AlgoliaResource;
  item: CardData;
  type: CardType;
};

const store = useStore<State>();



const toggleSelectFolderModal = (show: boolean, id: number) => {
  store.dispatch('toggleSelectFolderModal', { show, id, resource: props.resource });
};

const { isAuthenticated, user } = useUser();
const file = isAlgoliaResource(props.resource, props.type)
  ? undefined
  : props.resource.file_formats[0];
const { hasPermissions } = usePermissions(props.item.postType, props.item.isFree, file as string);
const mongoResource = isAlgoliaResource(props.resource, props.type) ? undefined : props.resource;
const { isDownloading, download } = useDownload(mongoResource);
const isPlusLiteMember = computed(() => user.value?.subscription?.code === 'plus_lite');

return { __sfc: true,store, props, toggleSelectFolderModal, isAuthenticated, user, file, hasPermissions, mongoResource, isDownloading, download, isPlusLiteMember }
}

})